import { useProfile } from "./DataHooks/useProfile";

export const useProfileParams = () => {
  const { profile, isLoading, isError } = useProfile();

  if (isLoading || isError) {
    return [[]];
  }
  return [profile.params];
};

//competitor flag
export const useIsComptr = () => {
  const [params] = useProfileParams();
  return params && params.isComptr;
};
